"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlacementDisplay = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alloyReactA = _interopRequireDefault(require("@adsk/alloy-react-a"));
var _CustomEventContext = require("../../CustomEventContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PlacementDisplay = _ref => {
  let {
    placementLink,
    placementText,
    shouldShowLink,
    issue
  } = _ref;
  const fireCustomEvent = (0, _CustomEventContext.useFireCustomEvent)();
  const onPlacementClick = (0, _react.useCallback)(e => {
    e.stopPropagation();
    if (fireCustomEvent) {
      const customEventData = (0, _CustomEventContext.createCustomEvent)({
        type: _CustomEventContext.CustomEventType.PlacementLinkClick,
        target: _CustomEventContext.CustomEventTarget.Link,
        data: {
          url: placementLink,
          issue
        }
      });
      fireCustomEvent(customEventData);
      if ((0, _CustomEventContext.isDefaultPrevented)(customEventData)) {
        e.preventDefault();
      }
    }
  }, [placementLink, fireCustomEvent]);
  if (shouldShowLink) {
    return /*#__PURE__*/_react.default.createElement(_alloyReactA.default, {
      href: placementLink,
      target: "_blank",
      onClick: e => onPlacementClick(e)
    }, placementText);
  }
  return /*#__PURE__*/_react.default.createElement("span", null, placementText);
};
exports.PlacementDisplay = PlacementDisplay;
//# sourceMappingURL=PlacementDisplay.js.map